var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1271(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55957,
    y: 1.2749,
    width: 19.6843,
    height: 14.4509,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5234 17H2.78906C1.25136 17 0 15.7288 0 14.1667V2.83333C0 1.27122 1.25136 0 2.78906 0H19.5234C21.0611 0 22.3125 1.27122 22.3125 2.83333V14.1667C22.3125 15.7288 21.0611 17 19.5234 17ZM2.78906 15.1111H19.5234C20.0357 15.1111 20.4531 14.688 20.4531 14.1667V3.02506L11.7401 10.1783C11.57 10.319 11.3636 10.3889 11.1562 10.3889C10.9489 10.3889 10.7425 10.319 10.5724 10.1783L1.85938 3.02506V14.1667C1.85938 14.688 2.2768 15.1111 2.78906 15.1111ZM18.8801 1.88889H3.43241L11.1562 8.22989L18.8801 1.88889Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23926 14.3101V2.68994C5.03925 5.05845 10.7091 9.81204 10.9887 9.87834C11.2684 9.94463 17.1614 5.1137 20.0729 2.68994V14.3101",
    stroke: "#674DA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1271);
export default __webpack_public_path__ + "static/media/Group 1271.802fb7271607f774c969c9adea76d266.svg";
export { ForwardRef as ReactComponent };